import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

export const draggableMultiValueLabelStyles = {
  container: css`
    display: flex;

    :hover,
    :focus,
    :active {
      .drag-icon {
        color: ${theme.colors.primary.main};
      }
    }
  `,
  labelValue: css`
    flex: 1;
  `,
  dragIcon: css`
    color: ${theme.colors.gray['700']};
    font-size: 18px;
    width: 13px;
    align-self: center;
  `,
};
